import React, { useRef } from 'react';
import { a } from '@react-spring/three';
import { usePartlyClouds, usePartlyCloud } from './use-partly-cloud';
export const WhiteCloud = ({ value, style }) => {
    const cloud = useRef();
    usePartlyCloud(cloud);
    return (React.createElement(a.mesh, { "material-opacity": style === null || style === void 0 ? void 0 : style.opacity.to((x) => x * value.opacity), ref: cloud, position: value.startpoint },
        React.createElement("circleBufferGeometry", { attach: "geometry", args: [value.radius, 128] }),
        React.createElement("meshBasicMaterial", { attach: "material", transparent: true, color: value.color })));
};
const PartlyCloudy = (props) => {
    var _a;
    const { clouds } = usePartlyClouds(props);
    const pY = (_a = props.style) === null || _a === void 0 ? void 0 : _a.opacity.to([0, 1], [2, 0]);
    return (React.createElement(a.group, { "position-y": pY }, clouds.map((cloud, index) => {
        return React.createElement(WhiteCloud, { key: index, value: cloud, style: props.style });
    })));
};
export default PartlyCloudy;
